import { WidgetState } from "@/apps/StudentExchangeProgressColumnWidget/models/store-viewmodel"
import actions from "@/apps/StudentExchangeProgressColumnWidget/store/actions"
import mutations from "@/apps/StudentExchangeProgressColumnWidget/store/mutations"
import getters from "@/apps/StudentExchangeProgressColumnWidget/store/getters"

export default {
    state: new WidgetState,
    actions: actions,
    mutations: mutations,
    getters: getters
}
